module.exports = __webpack_public_path__ + "static/media/Sy_for_Dummies2.0e0e9660.jpeg";